import actionTypes from "consts/actionTypes.js";

const initialState = {
  user: {
    loading: false,
    data: undefined,
    error: undefined,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PENDING_CPE_PENDING:
      return {
        ...state,
        user: {
          loading: true,
          error: undefined, // Empty error for retry
        },
      };
    case actionTypes.GET_PENDING_CPE_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          user: {
            loading: false,
            data: action.payload.result,
          },
        };
      } else {
        return {
          ...state,
          user: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.GET_PENDING_CPE_ERROR:
      return {
        ...state,
        user: {
          loading: false,
          error: action.error,
        },
      };
    case actionTypes.POST_ACTIVATE_CPE_PENDING:
      return {
        ...state,
        user: {
          loading: true,
          error: undefined, // Empty error for retry
        },
      };
    case actionTypes.POST_ACTIVATE_CPE_SUCCESS:
      if (action.payload.status) {
        return {
          ...state,
          user: {
            loading: false,
            data: action.payload.result,
          },
        };
      } else {
        return {
          ...state,
          user: {
            loading: false,
            error: action.payload.error,
          },
        };
      }
    case actionTypes.POST_ACTIVATE_CPE_ERROR:
      return {
        ...state,
        user: {
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/activations.js